import { BiCheck } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { Switch, Tooltip, Typography, message } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import Button from "../../components/Button";

import { useAuth } from "../../contexts/AuthContext";
import { UserPlanEnum } from "../../constants/plans";
import { Container, PlanosContainer } from "./styles";

import { UserPlanUpgradeEnum, getPlanOriginalPrice, getPlanPrice, planos, calculatePlanPrice } from "./planos";
import { apiPayment } from "../../services/payment";
import { PaymentModal } from "../Payment/PaymentModal";
import api from "../../services/api";
import { useClients } from "../../contexts/ClientsContext";
import { isMobile } from "../../utils";
import { IoMdArrowRoundBack } from "react-icons/io";

var getStatus: NodeJS.Timeout;

export interface HasPlan {
  basic: boolean;
  premium: boolean;
  concierge: boolean;
}

export const Planos = ({ hasPlan, selectedClient, onBack, onFinish, filters }: { hasPlan: false | HasPlan; selectedClient: any, onBack?: () => void, onFinish?: () => void, filters?: any }) => {
  const { user } = useAuth()
  const [selectedPlan, setSelectedPlan] = useState<any>();
  const [paymentModal, setPaymentModal] = useState(false);
  const [planUpgrade, setPlanUpgrade] = useState<UserPlanUpgradeEnum>();
  const [typeConcierge, setTypeConcierge] = useState('anual');
  const { getClients, setSelectedClient } = useClients();
  const [currentPlanValue, setCurrentPlanValue] = useState<number | undefined>()



  const handleSelectPlan = (plan: any, overridePrice?: number) => {

    // Aplicar desconto se existir (fallback)
    let planWithDiscount = { ...plan };

    if (user.user?.discount && !plan.type.includes('_BASIC')) {
      const discountPercentage = getMinDiscount(plan.type, user.user.discount);
      const originalPrice = getPlanOriginalPrice(plan, hasPlan);

      const discountedPrice = originalPrice - (originalPrice * discountPercentage / 100);

      planWithDiscount = {
        ...plan,
        price: discountedPrice,
        originalPrice: discountedPrice,
        fullPrice: discountedPrice * 12
      };

    }
    // Se foi passado um preço calculado, ele prevalece sobre o fallback
    if (overridePrice !== undefined) {
      const normalized = Math.round(overridePrice * 100) / 100;
      planWithDiscount = {
        ...planWithDiscount,
        price: normalized,
        originalPrice: normalized,
        fullPrice: normalized * 12,
      };
    }
    setPaymentModal(true);
    setSelectedPlan(planWithDiscount);

  };

  const checkWasPaid = useCallback(
    (id: string, delay: number = 2) => {
      let attempts = 0;
      getStatus = setInterval(async () => {
        const token = localStorage.getItem("@VeloTax:token");
        apiPayment
          .get(`/user-plan/plan-info`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            if (res.data?.active) {
              clearInterval(getStatus);
              message.success("Pagamento Confirmado com sucesso!");
            }
          })
          .finally(() => {
            attempts += 1;
            if (attempts > 100) {
              clearInterval(getStatus);
            }
          });
      }, delay * 1000);
    },
    []
  );

  const handleSuccess = (data: any) => {
    onFinish && onFinish()
    // checkWasPaid(data.paymentId, 4);
  };

  const stopIntervalPix = () => {
    if (getStatus) clearInterval(getStatus);
  };

  useEffect(() => {
    // return () => getStatus && clearInterval(getStatus);
  }, [checkWasPaid]);

  // useEffect(() => {
  //   // setPaymentModal(true);
  //   setSelectedPlan();
  // }, [user?.user?.userPlanInfoVelotax?.type]);

  const onChange = (e: any) => {
    if (e) setTypeConcierge('mensal');
    else setTypeConcierge('anual');
  }

  const createPlanFromSelectedClient = async () => {
    try {
      const usernames = [selectedClient.username];
      const { data } = await api.post("/plans", {
        usernames,
        planName: selectedPlan?.type,
        type: typeConcierge
      });
      
      // Chama getClients com o username do cliente para mantê-lo selecionado
      await getClients({ searchText: selectedClient.username });
      
      // Fecha o modal
      setPaymentModal(false);
      
      message.success(
        `${data.count} Clientes adicionados no Plano premium com sucesso`
      );
      
    } catch (err) {
      message.error("Ocorreu um erro ao adicionar os clientes no plano");
    }
  };

  const getMinDiscount = (planType: string, discount: number) => {
    if (typeConcierge === "mensal") {
      if (planType.includes('_PRO')) {
        if (discount >= 25) return 25.03;
        else return discount;
      }
      else if (planType.includes('_CONCIERGE')) {
        if (discount >= 40) return 40.04;
        else return discount;
      }
      else return discount;
    }
    else {
      if (planType.includes('_PRO')) {
        if (discount >= 33) return 33.38898164;
        else return discount;
      }
      else if (planType.includes('_CONCIERGE')) {
        if (discount >= 50) return 50.06257822;
        else return discount;
      }
      else return discount;
    }
  }

  const getMinDiscountLabel = (planType: string, discount: number) => {
    if (typeConcierge === "mensal") {
      if (planType.includes('_PRO')) {
        if (discount >= 50) return 50;
        else return discount;
      }
      else if (planType.includes('_CONCIERGE')) {
        if (discount >= 60) return 60;
        else return discount;
      }
      else return discount;
    }
    else {
      if (planType.includes('_PRO')) {
        if (discount >= 50) return 50;
        else return discount;
      }
      else if (planType.includes('_CONCIERGE')) {
        if (discount >= 60) return 60;
        else return discount;
      }
      else return discount;
    }
  }

  return (
    <Container className="velotax-container">
             <div className="velotax-content">
        <Typography.Title className="page-title">
          {onBack && <Tooltip title="Voltar">
            <button onClick={onBack}>
              <IoMdArrowRoundBack />
            </button>
          </Tooltip>}
          Selecione seu plano
        </Typography.Title>
        <div className="divider" />
        {user.user.liberadaContratacao
          ?
          <PlanosContainer isMobile={isMobile()}>
            {planos.map((plan: { type: any; name?: any; popular?: any; for?: any; includes?: any; benefits?: any; originalPrice?: number; price?: number; }) => {
              const mainBasicPrice = planos.find(e => e.type === 'VELOTAX_MAIN_BASIC')?.originalPrice as number;
              const mainProPlan = planos.find(e => e.type === 'VELOTAX_MAIN_PRO') as { originalPrice: number; type: UserPlanEnum };
              const conciergePlan = planos.find(e => e.type === 'VELOTAX_MAIN_CONCIERGE') as { originalPrice: number; type: UserPlanEnum };
              const mainProPlanPriceWithDiscount = (getPlanOriginalPrice(mainProPlan, false) - (((getPlanOriginalPrice(mainProPlan, false)) * getMinDiscount(mainProPlan.type, user.user?.discount as number) / 100)))
              const conciergePlanPriceWithDiscount = (getPlanOriginalPrice(conciergePlan, false) - (((getPlanOriginalPrice(conciergePlan, false)) * getMinDiscount(conciergePlan.type, user.user?.discount as number) / 100)))

              return (
                (typeConcierge == 'mensal' && !plan.type.includes('_MONTH')) ? <></> :
                  <>
                    <div className={`plan 
            ${(typeConcierge == 'anual' && plan.type.includes('_MONTH')) ? 'hide-plan' : ''}
            ${user.user?.discount ? 'discount' : ''}
          `} key={plan.name}>
                      {plan.popular && <div className="plan-popular">Mais vendido</div>}
                      <Typography.Paragraph className="plan-name">
                        {plan.name}
                      </Typography.Paragraph>
                      <Typography.Text className="plan-for">{plan.for}</Typography.Text>
                      {(user.user?.discount && user.user.liberadaContratacao && !plan.type.includes('_BASIC'))
                        ?
                        <>
                          <div className="crossed-off"></div>
                          <span className="price-crossed-off">
                            R${" "}
                            {plan.type.includes('_PRO') 
                              ? "79,90"
                              : plan.type.includes('_CONCIERGE')
                              ? "99,90"
                              : getPlanOriginalPrice(plan as { originalPrice: number; type: UserPlanEnum }, false)
                                ?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                            }
                          </span>
                          <span className="price-crossed-off-discount">{user.user?.discount ? `${getMinDiscountLabel(plan.type, user.user?.discount)}%` : '0%'} desconto</span>
                        </>
                        : 
                        <>
                          {/* Espaço invisível para manter alinhamento dos botões */}
                          <div style={{ height: '16px', visibility: 'hidden' }}>
                            <div className="crossed-off"></div>
                            <span className="price-crossed-off">R$ 0,00</span>
                            <span className="price-crossed-off-discount">0% desconto</span>
                          </div>
                        </>
                      }
                      <Typography.Paragraph className="plan-price">
                        {hasPlan && hasPlan?.basic &&
                          (plan.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE ||
                            plan.type === UserPlanEnum.VELOTAX_MAIN_PRO ||
                            plan.type === UserPlanEnum.XP_CONCIERGE ||
                            plan.type === UserPlanEnum.XP_PRO)
                          && <div className="plus">+</div>}
                        {hasPlan && hasPlan?.premium && (plan.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE || plan.type === UserPlanEnum.XP_CONCIERGE) && <div className="plus">+</div>}
                        R${" "}
                        {/* teste */}
                        <span className="plan-price-main">
                          {<>
                            {
                              plan.type.includes('MONTH') && <>{(user.user?.discount && !plan.type.includes('_BASIC'))
                                ? (getPlanOriginalPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan) - ((getPlanOriginalPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan) * getMinDiscount(plan.type, user.user?.discount) / 100)))
                                  ?.toLocaleString("pt-br", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                : getPlanOriginalPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan)
                                  ?.toLocaleString("pt-br", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  .split(",")[0]}</>
                            }</>
                          }
                          {
                            (user.user?.discount && !plan.type.includes('_BASIC') && !plan.type.includes('MONTH'))
                              ? calculatePlanPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan, mainBasicPrice, mainProPlanPriceWithDiscount, conciergePlanPriceWithDiscount)
                                ?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : !plan.type.includes('MONTH') && <>{getPlanOriginalPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan)
                                ?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                .split(",")[0]}</>
                          }
                        </span>
                        {(!user.user?.discount || plan.type.includes('_BASIC')) &&
                          <>
                            ,
                            {
                              getPlanPrice(plan as { price: number; type: UserPlanEnum }, hasPlan)
                                ?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                .split(",")[1]
                            }
                          </>
                        }
                      </Typography.Paragraph>
                      <Typography.Text className="plan-price-desc">
                        {(typeConcierge == 'mensal') ? 'por mês' : 'por mês no plano anual'}
                      </Typography.Text>
                      <Button
                        block
                        size="large"
                        type="primary"
                        disabled={
                          (hasPlan &&
                            (
                              (hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                              (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                              (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) ||
                              (hasPlan.basic && plan?.type === UserPlanEnum.XP_BASIC) ||
                              (hasPlan.premium && plan?.type === UserPlanEnum.XP_BASIC) ||
                              (hasPlan.premium && plan?.type === UserPlanEnum.XP_PRO) ||
                              (hasPlan.concierge)
                            ))
                        }
                        onClick={() => {
                          if (hasPlan) {
                            setPlanUpgrade(
                              hasPlan.premium &&
                                plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
                                ? UserPlanUpgradeEnum.PRO_TO_CONCIERGE
                                : hasPlan.basic &&
                                  plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO
                                  ? UserPlanUpgradeEnum.BASIC_TO_PRO
                                  : hasPlan.basic &&
                                    plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
                                    ? UserPlanUpgradeEnum.BASIC_TO_CONCIERGE
                                    : undefined
                            );
                          }
                          const computed = calculatePlanPrice(plan as { originalPrice: number; type: UserPlanEnum }, hasPlan, mainBasicPrice, mainProPlanPriceWithDiscount, conciergePlanPriceWithDiscount);
                          const normalized = computed !== undefined ? Math.round(computed * 100) / 100 : undefined;
                          setCurrentPlanValue(computed);
                          handleSelectPlan(plan, normalized);
                        }}
                      >
                        {!hasPlan
                          ? "Selecionar"
                          : (hasPlan.basic &&
                            plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                            (hasPlan.premium &&
                              plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) ||
                            (hasPlan.concierge &&
                              plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) ||
                            (hasPlan.basic &&
                              plan?.type === UserPlanEnum.XP_BASIC) ||
                            (hasPlan.premium &&
                              plan?.type === UserPlanEnum.XP_PRO) ||
                            (hasPlan.concierge &&
                              plan?.type === UserPlanEnum.XP_CONCIERGE)
                            ? "Ativo"
                            : "Fazer upgrade"}
                      </Button>
                      <Typography.Text className="plan-includes">
                        {plan.includes}
                      </Typography.Text>
                      <div className="plan-benefits">
                        {plan.benefits.map((benefit: string, index: number) => (
                          <div className="plan-benefit" key={index}>
                            <BiCheck className="check" />
                            {benefit.split("{")[0]}
                            {benefit.split("{")?.[1]?.length > 0 ? (
                              <Tooltip
                                title={benefit.split("{")?.[1].replace("}", "")}
                                getPopupContainer={(target) => target.parentElement!}
                              >
                                <InfoCircleOutlined className="info" />
                              </Tooltip>
                            ) : (
                              <></>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
              )
            })}
          </PlanosContainer>
          :
          <PlanosContainer isMobile={isMobile()}>
            {planos.map((plan) => (
              <>
                {plan.type.includes('_MONTH') ? <></> :
                  <div className="plan" key={plan.name}>
                    {plan.popular && <div className="plan-popular">Mais vendido</div>}
                    <Typography.Paragraph className="plan-name">
                      {plan.name}
                    </Typography.Paragraph>
                    <Typography.Text className="plan-for">{plan.for}</Typography.Text>
                    <Typography.Paragraph className="plan-price">
                      {hasPlan && hasPlan?.basic &&
                        (plan.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE ||
                          plan.type === UserPlanEnum.VELOTAX_MAIN_PRO ||
                          plan.type === UserPlanEnum.XP_CONCIERGE ||
                          plan.type === UserPlanEnum.XP_PRO)
                        && <div className="plus">+</div>}
                      {hasPlan && hasPlan?.premium && (plan.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE || plan.type === UserPlanEnum.XP_CONCIERGE) && <div className="plus">+</div>}
                      R${" "}
                      <span className="plan-price-main">
                        {
                          getPlanOriginalPrice(plan, hasPlan)
                            ?.toLocaleString("pt-br", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            .split(",")[0]
                        }
                      </span>
                      ,
                      {
                        getPlanOriginalPrice(plan, hasPlan)
                          ?.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                          .split(",")[1]
                      }
                    </Typography.Paragraph>
                    <Typography.Text className="plan-price-desc">
                      {/* {hasPlan && hasPlan?.premium && plan.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE && <span className="plus">R$ 79,90 </span>} */}
                      por mês no plano anual
                    </Typography.Text>
                    <Button
                      block
                      size="large"
                      type="primary"
                      disabled={
                        true
                        // (hasPlan &&
                        //   (
                        //     (hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                        //     (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                        //     (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) ||
                        //     (hasPlan.basic && plan?.type === UserPlanEnum.XP_BASIC) ||
                        //     (hasPlan.premium && plan?.type === UserPlanEnum.XP_BASIC) ||
                        //     (hasPlan.premium && plan?.type === UserPlanEnum.XP_PRO) ||
                        //     (hasPlan.concierge)
                        //   ))
                      }
                      onClick={() => {
                        if (hasPlan) {
                          setPlanUpgrade(
                            hasPlan.premium &&
                              plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
                              ? UserPlanUpgradeEnum.PRO_TO_CONCIERGE
                              : hasPlan.basic &&
                                plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO
                                ? UserPlanUpgradeEnum.BASIC_TO_PRO
                                : hasPlan.basic &&
                                  plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
                                  ? UserPlanUpgradeEnum.BASIC_TO_CONCIERGE
                                  : undefined
                          );
                        }
                        handleSelectPlan(plan);
                      }}
                    >
                      {!hasPlan
                        ? "Selecionar"
                        : (hasPlan.basic &&
                          plan?.type === UserPlanEnum.VELOTAX_MAIN_BASIC) ||
                          (hasPlan.premium &&
                            plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) ||
                          (hasPlan.concierge &&
                            plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) ||
                          (hasPlan.basic &&
                            plan?.type === UserPlanEnum.XP_BASIC) ||
                          (hasPlan.premium &&
                            plan?.type === UserPlanEnum.XP_PRO) ||
                          (hasPlan.concierge &&
                            plan?.type === UserPlanEnum.XP_CONCIERGE)
                          ? "Ativo"
                          : "Fazer upgrade"}
                    </Button>
                    <Typography.Text className="plan-includes">
                      {plan.includes}
                    </Typography.Text>
                    <div className="plan-benefits">
                      {plan.benefits.map((benefit, index) => (
                        <div className="plan-benefit" key={index}>
                          <BiCheck className="check" />
                          {benefit.split("{")[0]}
                          {benefit.split("{")?.[1]?.length > 0 ? (
                            <Tooltip
                              title={benefit.split("{")?.[1].replace("}", "")}
                              getPopupContainer={(target) => target.parentElement!}
                            >
                              <InfoCircleOutlined className="info" />
                            </Tooltip>
                          ) : (
                            <></>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </>
            ))}
          </PlanosContainer>
        }
      </div>
      <PaymentModal
        hideDarfDownload
        show={paymentModal}
        callDarf={() => { }}
        planCurrent={selectedPlan}
        onSucessPix={checkWasPaid}
        onSucessCreditCard={handleSuccess}
        disableCreditCardOption={typeConcierge == 'mensal' ? true : false}
        createConciergePlan={createPlanFromSelectedClient}
        paymentData={{
          planUpgrade,
          type: selectedPlan?.type,
          isPlan: true,
          stopIntervalPix,
        }}
        onCancel={() => {
          setPaymentModal(false);
          setSelectedPlan(undefined);
          // setDirectPayment(false);
        }}
        clientSelected={selectedClient}
        typeConcierge={typeConcierge}
        filters={filters}
        onlyInvoiceOption={true}
      />
    </Container>
  );
};